export const SORT_TYPES = {
  JOIN_DESC: 'join-desc',
  JOIN_ASC: 'join-asc',
  NAME_ASC: 'name-asc',
  PURCHASE_DESC: 'purchase-desc',
};

export const SORT_OPTIONS = [
  { value: SORT_TYPES.JOIN_DESC, label: 'Join Date ↓' },
  { value: SORT_TYPES.JOIN_ASC, label: 'Join Date ↑' },
  { value: SORT_TYPES.NAME_ASC, label: 'Name A–Z' },
  { value: SORT_TYPES.PURCHASE_DESC, label: 'Most Purchases' },
];

export const ROLE_TYPES = {
  ALL: '',
  ADMIN: 'ADMIN',
  HOST: 'HOST',
  MEMBER: 'MEMBER',
};

export const ROLE_OPTIONS = [
  { value: ROLE_TYPES.ALL, label: 'All Permissions' },
  { value: ROLE_TYPES.ADMIN, label: 'Admin' },
  { value: ROLE_TYPES.HOST, label: 'Host' },
  { value: ROLE_TYPES.MEMBER, label: 'Member' },
];

export const AVATAR_BG_CLASSES = ['av-purple', 'av-teal', 'av-amber', 'av-coral', 'av-blue'];
